import { createRoute } from "@tanstack/solid-router";
import { importantRoute } from "./important";

export const importantTodoRoute = createRoute({
  getParentRoute: () => importantRoute,
  path: "/todo/$todoId",
  component: ImportantTodoDetailRoutePage,
});

function ImportantTodoDetailRoutePage() {
  return null;
}
